export default "__VITE_ASSET__DH1b5Xnw__"